(function () {
  var burger = document.querySelector('[data-tk-burger]');
  var menu = document.getElementById('tk-mnav');
  if (!burger || !menu) return;
  burger.setAttribute('aria-expanded', 'false');
  burger.addEventListener('click', function () {
    var open = menu.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('click', function (e) {
    if (!menu.contains(e.target) && !burger.contains(e.target)) {
      menu.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      menu.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
    }
  });
}());

(function () {
  var form = document.querySelector('[data-tk-enquiry]');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = function (n) { var f = form.elements[n]; return f ? f.value : ''; };
    var body = ['Name: ' + v('name'), 'Email: ' + v('email'), 'Company: ' + v('company'), '', v('message')].join('\n');
    var subject = 'Project enquiry' + (v('company') ? ' \u2014 ' + v('company') : '');
    window.location.href = 'mailto:contact@devsource.site?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  });
}());
